import React, { useMemo } from 'react';
import type { KaliaResource, PositionedEvent } from './types';
import EventPopover from '~/components/treatment/appointment/calendar/popover/EventPopover';
import { buildEventContentArg } from './eventAdapter';

type Props = {
    event: PositionedEvent;
    resources: KaliaResource[];
};

function KaliaCalendarEvent({ event, resources }: Props) {
    const eventContentArg = useMemo(
        () => buildEventContentArg(event, resources),
        [event, resources]
    );

    const isBlocker = event.id.startsWith('schedule-') && event.metadata?.type === 'BLOCKED';

    const style = useMemo(() => {
        const left = `${(event.lane / event.totalLanes) * 100}%`;
        const width = `${(1 / event.totalLanes) * 100}%`;

        return {
            position: 'absolute' as const,
            top: event.top,
            height: Math.max(event.height, 10),
            left,
            width,
            zIndex: isBlocker ? 1 : 2,
        };
    }, [event.top, event.height, event.lane, event.totalLanes, isBlocker]);
    const bgColor = isBlocker ? '#9aa0ae' : (event.color || '#bdd7a4');

    return (
        <div style={style}>
            <div
                className='absolute inset-0 rounded-[3px] border border-white/60 overflow-hidden cursor-pointer'
                style={{
                    backgroundColor: bgColor,
                    borderLeft: `3px solid color-mix(in srgb, ${bgColor} 70%, black)`,
                }}
            >
                <EventPopover info={eventContentArg} />
            </div>
        </div>
    );
}

export default React.memo(KaliaCalendarEvent);
